import { PureComponent } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { delay } from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'

import styles from './index.css'
import AttributeInfo from './AttributeInfo'
import SpecInfo from './SpecInfo'
import BrandIDInfo from './BrandIDInfo'
import { ProposalBlock } from '@vzmi/shp_shared_compo'
import { determineSpecLevel, getFinalAttributesForTransient, getSpecAttributeFieldByLevel, getFormValues } from '../../Common/ProposalForm/Shared/util'
import { FormValueSelector } from '../../../Common/forms'
import { UPDATE_LISTING_FORM_KEY, PROPOSAL_PHASE_TYPE, ATTRIBUTE_CONSTRAINTS_TYPE } from '../../../../constants/proposalTypes'
import { getParsedTransientData } from '../../Common/ProposalForm/Shared/TransientDataUtil'
import { getOuterSpecs, getModelsForUpdateAttr } from '../../UpdateListing/helpers/updateAttrHelper'
import { TRANSIENT_FIELD_KEY } from '../../Shared'

// 記憶已經存在的屬性
const getMemoizeAttributes = _.memoize(
  getFinalAttributesForTransient,
  (transientModel, struDataAttrCluster) => JSON.stringify(transientModel) + JSON.stringify(struDataAttrCluster)
)

/**
 * 選取 Spec 需要的 redux-from state field value
 */
const fieldSelector = select => ({
  phase: select('setting.phase'),
  readOnly: select('setting.readOnly'),
  isPM: select('setting.user.identity.isPM'),
  mismatchedCluster: select('setting.mismatchedCluster'),
  candidateStruDataClusterList: select('setting.candidateStruDataClusterList'),
  mustShowFormError: select('mustShowFormError'),
  productStruDataAttrClusterId: select('product.struDataAttrClusterId')
})

export const convertRecentlyData = (currentAttributes, recentlyAttributes) => {
  const recentSpecMap = _.keyBy(recentlyAttributes, 'name')
  const updatedSpec = _.reduce(currentAttributes, (result, spec) => {
    const recentVal = _.get(recentSpecMap, `${spec.name}.values`)
    if (spec.constraints.type === 'custom') {
      if (!recentVal) {
        // 如果在近期 attributes 中找不到相應的 name ，則排除該筆資料
        return result
      }
      spec.values = recentVal
    } else if (recentVal) {
      // 如果 name 匹配且類型不是 custom ，則將當前 values 對應到近期的 values
      spec.values = recentVal
    } else {
      // 如果 name 不匹配且類型不是 custom，則將 values 設為 null
      spec.values = null
    }

    result.push(spec)
    return result
  }, [])
  return updatedSpec
}
export class Spec extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      recentlyAttributes: {},
      recentlyAttributeDisplayMode: '',
      isRecentlyStatus: false
    }
  }

  triggerFieldChange = (...props) => {
    const { change } = this.props
    return change(...props)
  }

  onRecentlyAttributesChange = (recentlyCategoryData, isRecentlyStatus) => {
    const { attributes, attributeDisplayMode } = recentlyCategoryData
    this.setState({
      recentlyAttributes: attributes,
      recentlyAttributeDisplayMode: attributeDisplayMode,
      isRecentlyStatus
    })
  }

  syncTransientAttributes = async (transientField, transientModel, struDataAttrCluster) => {
    // 待觸發當下的 state 更新完成下一次再執行 sync
    await delay(0)

    const { proposalType, form, change, reduxFormState, fromClone } = this.props
    const initiallyFetchedListing = _.get(form, 'initiallyFetchedListing')
    const isNeedUpdateTransient = (
      !_.isEmpty(
        _.get(initiallyFetchedListing, 'productStructuredDataList')
      ) ||
      // 沒有規格表轉換的資料代表說現在資料都放在 INVALID_TRANSIENT_KEY 裡
      // 所以需要重新 sync TransientAttributes 才能讓 [商品屬性][商品規格] 吃到對應欄位的表單資料
      _.isEmpty(
        _.get(form, TRANSIENT_FIELD_KEY)
      )
    )
    // 修改規格表當規格表消失時需要在使用者重新選擇後寫入賣場的商品屬性
    if (proposalType === PROPOSAL_TYPE.UPDATE_ATTRIBUTE && isNeedUpdateTransient) {
      const {
        form: {
          subStationId,
          setting = {},
          product = {}
        } = {},
        change
      } = this.props
      // 將賣場的商品屬性轉換成商品屬性欄位使用的格式
      const models = getModelsForUpdateAttr(_.get(initiallyFetchedListing, 'models', []))
      // 取得 transient 裡要使用的規格格式
      const specs = getOuterSpecs(models)
      const formData = {
        subStationId,
        product: _.merge(product, { models, specs })
      }
      // 重新轉換 transient 取代一開始沒有規格表的資料
      const activeTransientData = getParsedTransientData(setting, formData)
      change(transientField, activeTransientData)
    }

    const { withSpecLevel: hasSpecLevel } = determineSpecLevel(transientModel.hasSpecLevel)
    const attrKey = `${transientField}.${getSpecAttributeFieldByLevel(hasSpecLevel)}`
    let attributes = getMemoizeAttributes(transientModel, struDataAttrCluster) || [] // 主attributes

    // 取得點選後近期使用狀態
    const { recentlyAttributes, recentlyAttributeDisplayMode, isRecentlyStatus } = this.state

    // 取得點選近期使用reduxFormState subStationId,catItemId,struDataAttrClusterId value
    const formValues = _.get(reduxFormState, 'values', {})
    const readOnly = _.get(formValues, 'setting.readOnly', false)
    const mustShowFormError = _.get(formValues, 'mustShowFormError', false)
    const { array: reduxFormArray } = this.props

    // trigger remove all to sync errors
    // an workaround to replace field array ref: https://github.com/erikras/redux-form/issues/2058
    reduxFormArray.removeAll(attrKey)

    const isCreateNewProposal = [PROPOSAL_TYPE.NEW_LISTING, PROPOSAL_TYPE.NEW_PRODUCT].includes(proposalType)
    // 只有修改頁會進入，確認、檢視頁跳過
    // 修改規格表無法進到這段，因為props沒有傳入match會報錯，限定newListing&newProduct進入
    if (!readOnly && isCreateNewProposal) {
      const { match: { params: { phase } } } = this.props
      switch (phase) {
        case PROPOSAL_PHASE_TYPE.COMPOSE: {
          // 草稿跟儲存暫不提案不套用近期使用
          // 判斷是否點選近期此用資料
          const isDraft = !_.isUndefined(_.get(HistoryUtil.retrieveQueryParams(this.props), 'id'))
          if (fromClone === true || isDraft || _.isEmpty(recentlyAttributes)) {
            if (isRecentlyStatus) {
              attributes = convertRecentlyData(attributes, recentlyAttributes)
            }
            return change(attrKey, attributes)
          } else {
            // 過濾attributes沒有的(自訂規格)obj
            const moreAttrs = _.filter(recentlyAttributes, (o) => { return !attributes.find(x => x.name === o.name) })

            if (hasSpecLevel) { // 判斷商品屬性[有選項]
              const hasAddSpecs = _.get(transientModel, 'spec', []) // 切換有選項 尚未選擇屬性hasAddSpecs[0]為 {}

              if (!_.isEmpty(hasAddSpecs[0]) && hasAddSpecs.length > 0) { // 先判斷有增加屬性hasAddSpecs
                const newWithLevel = _.filter(attributes, (o) => { return !hasAddSpecs.find(x => _.get(x, 'selectedOption.cluster.name', '') === o.name) }) // 重組規格表

                // 點擊近期使用重組 attributes
                if (isRecentlyStatus) {
                  const recentSpecMap = _.keyBy(recentlyAttributes, 'name')
                  let insertAttributes = _.map(newWithLevel, ele => {
                    const values = _.get(recentSpecMap, [ele.name, 'values'])
                    return values ? { ...ele, values } : ele
                  })
                  insertAttributes = convertRecentlyData(insertAttributes, recentlyAttributes)
                  return change(attrKey, insertAttributes)
                }

                return change(attrKey, newWithLevel)
              }
            }
            // 這邊組成近期資料
            const newMoreAttrs = _.map(moreAttrs, (item) => { // 組成redux form 自訂規格 fields
              const itemValues = item.values !== null ? item.values.join() : item.values
              return {
                ...item,
                constraints: { type: ATTRIBUTE_CONSTRAINTS_TYPE.CUSTOM },
                hasOTHER: false,
                options: [{ label: itemValues, value: itemValues }]
              }
            })
            const customOptions = !_.isEmpty(moreAttrs) ? newMoreAttrs : moreAttrs
            attributes = _.concat(attributes, customOptions) // 沒有的(自訂規格)obj，加入到主attributes中
            let insertAttributes = _.map(attributes, (ele) => { // 重組主attributes.value，將近期使用value加進去
              const value = recentlyAttributes.find(x => x.name === ele.name)
              return value ? { ...ele, values: value.values } : ele
            })
            if (mustShowFormError) { // 僅在系統重新驗證redirect回來進這段，mustShowFormError為true
              // transientModel => withoutLevel : 無選項值 ，withLevel : 有選項值
              // 若切換有無選項，因為當前attributes 可能沒有另一個值，必須把另一個當預設
              const withoutLevel = _.get(transientModel, 'attributes.withoutLevel', []) // 是無選項，帶當前attributes
              const withLevel = _.get(transientModel, 'attributes.withLevel', []) // 是有選項，帶當前attributes
              const withLevelIsEmpty = _.isEmpty(withLevel) ? withoutLevel : withLevel
              const withoutLevelIsEmpty = _.isEmpty(withoutLevel) ? withLevel : withoutLevel
              const attributesResult = hasSpecLevel ? withLevelIsEmpty : withoutLevelIsEmpty
              change(attrKey, attributesResult)
              change('mustShowFormError', false) // 須將mustShowFormError設定回來，避免出現驗證錯誤訊息
            } else {
              // 點擊近期使用重組 attributes
              if (isRecentlyStatus) {
                insertAttributes = convertRecentlyData(insertAttributes, recentlyAttributes)
              }
              change(attrKey, insertAttributes)
              change('product.attributeDisplayMode', recentlyAttributeDisplayMode) // 改變[表格式][條列式] 狀態
            }
          }
          break
        }
        default: {
          change(attrKey, attributes)
        }
      }
    } else { // 修改規格表
      change(attrKey, attributes)
    }
  }

  render () {
    const {
      actions,
      proposalType,
      fromClone,
      brandFeToggle,
      reduxFormState
    } = this.props
    const meta = _.get(this.props, 'reduxFormState.meta', {})
    const isNewProposal = !fromClone
    const formValues = getFormValues(reduxFormState)
    return (
      <FormValueSelector selector={fieldSelector}>
        {
          values => {
            const {
              isPM,
              phase,
              readOnly,
              mismatchedCluster,
              candidateStruDataClusterList,
              mustShowFormError,
              productStruDataAttrClusterId
            } = values

            return (
              <div
                className={styles.Spec}
                data-role='compose-spec'
              >

                <ProposalBlock className={styles.imageBlock}>
                  <AttributeInfo
                    proposalType={proposalType}
                    triggerFieldChange={this.triggerFieldChange}
                    syncTransientAttributes={this.syncTransientAttributes}
                    actions={actions}
                    readOnly={proposalType === PROPOSAL_TYPE.UPDATE_ATTRIBUTE || readOnly}
                    phase={phase}
                    mismatchedCluster={mismatchedCluster}
                    candidateStruDataClusterList={candidateStruDataClusterList}
                    productStruDataAttrClusterId={productStruDataAttrClusterId}
                    isPM={isPM}
                    meta={meta}
                    mustShowFormError={mustShowFormError}
                    showErrorOnActive={isNewProposal}
                    onRecentlyAttributesChange={this.onRecentlyAttributesChange}
                  />
                </ProposalBlock>
                <ProposalBlock>
                  <SpecInfo
                    proposalType={proposalType}
                    triggerFieldChange={this.triggerFieldChange}
                    syncTransientAttributes={this.syncTransientAttributes}
                    actions={actions}
                    readOnly={readOnly}
                    mustShowFormError={mustShowFormError}
                    showErrorOnActive={isNewProposal}
                  />
                </ProposalBlock>
                { brandFeToggle && (
                  <ProposalBlock>
                    <BrandIDInfo
                      proposalType={proposalType}
                      triggerFieldChange={this.triggerFieldChange}
                      syncTransientAttributes={this.syncTransientAttributes}
                      readOnly={readOnly}
                      mustShowFormError={mustShowFormError}
                      showErrorOnActive={isNewProposal}
                      fetchBrands={actions.fetchBrands}
                      listing={formValues}
                    />
                  </ProposalBlock>
                )}
              </div>

            )
          }
        }
      </FormValueSelector>
    )
  }
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const PARSE_TRANSIENT_FIELDS = [
  'subStationId',
  'initiallyFetchedListing',
  'setting',
  'product',
  TRANSIENT_FIELD_KEY
]

const SpecContainer = connect((state, ownProps) => {
  const location = _.get(state, 'router.location', {})
  const { fromClone } = HistoryUtil.retrieveQueryParams({ location })
  const isCloneListing = _.get(ownProps, 'match.params.feature') === PROPOSAL_TYPE.CLONE_LISTING
  const { flags } = ownProps
  return {
    fromClone: fromClone === 'true' || isCloneListing,
    form: selector(state, ...PARSE_TRANSIENT_FIELDS),
    brandFeToggle: getFeatureToggle(flags, 'sp_brand_fe')
  }
})(Spec)

export default SpecContainer
